import React from 'react'

export default ({ route }) => <div dangerouslySetInnerHTML={{ __html: route.page.data.body }} />



// WEBPACK FOOTER //
// ../wrappers/html.js